/**
 * Shared enums used across features and domains.
 * Keep cross-cutting enums here as the single source of truth.
 */
export enum PassengerTypeEnum {
  Adult = 'adult',
  Child = 'child',
  Infant = 'infant',
}

/**
 * Passenger type codes from booking data.
 */
export enum PassengerTypeCode {
  Adult = 1,
  // eslint-disable-next-line no-magic-numbers
  Child = 6,
  // eslint-disable-next-line no-magic-numbers
  Infant = 5,
}

/**
 * Service Request (SSR) types for ancillary services.
 */
export enum SsrType {
  SEAT = 'SEAT',
  HANDBAGGAGE = 'HANDBAGGAGE',
  CHECKEDBAGGAGE = 'BAGGAGE',
  MEAL = 'MEAL',
  IFE = 'IFE',
  LOUNGE = 'LOUNGE',
  ASSIST = 'ASSIST',
}

/**
 * Check-in status for passengers.
 */
export enum CheckInStatus {
  NOT_CHECKED_IN = 'Not checked in',
  INCOMPLETE = 'incomplete',
  CHECKED_IN = 'checked-in',
}

/**
 * Status string values from API.
 */
export enum StatusType {
  CHECKED_IN = 'CheckedIn',
  NOT_CHECKED_IN = 'NotCheckedIn',
}
